import styled from 'styled-components';
import {device} from 'styled/device';

export const StyledCaseRecommendations = styled.div`
  display: flex;
  flex-direction: column;
  padding: 100px 0;
  margin-top: 50px;

  @media (max-width: ${device.mobileM}) {
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  .recomendationsTitle {
    font-size: 44px;
    font-weight: 500;
    color: #23262f;
    text-align: center;
    padding: 15px 0;
  }

  .recomendationsSubTitle {
    font-size: 18px;
    padding-bottom: 30px;
    text-align: center;
    color: #777e91;
  }

  @media (max-width: ${device.mobileM}) {
    .recomendationsTitle {
      font-weight: 400;
      line-height: 1.3;
      padding: 15px 0;
    }

    .recomendationsSubTitle {
      padding-bottom: 50px;
    }
  }
`;

export const RecommendationsOff25 = styled.div`
  border: 2px solid #32d7be;
  border-radius: 4px;
  /* height: 25px; */
  color: #32d7be;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;

  @media (max-width: ${device.mobileM}) {
    border: 3px solid #32d7be;
    font-size: 18px;
    padding: 4px 12px;
  }
`;
